import * as React from "react";
import { useFilterLogic } from "./components/filter_logic";
import FilterButton from "./components/filter_button";
import { filterOptions } from "./components/filter_options";
import ResponsiveFilterButton from "./components/responsive_filter";

import images from "./components/assets/images";

interface FilterComponentProps {
  onFilterChange?: (filters: string[]) => void;
}

const FilterComponent: React.FC<FilterComponentProps> = ({ onFilterChange }) => {
  const { selectedFilters, scrollContainerRef, toggleFilter, clearAllFilters } =
    useFilterLogic(filterOptions, onFilterChange);

  return (
    <div className="min-h-[100px] md:h-[235px] relative p-4 rounded-t-mediumRound bg-primary">
      <div className="flex flex-col md:flex-row items-center justify-between">
        {/* Responsive filter button for small screens, centered */}
        <div className="md:hidden w-full flex justify-center items-center h-full">
          <ResponsiveFilterButton
            selectedFilters={selectedFilters}
            filterOptions={filterOptions}
            toggleFilter={toggleFilter}
            clearAllFilters={clearAllFilters}
          />
        </div>

        {/* Original filter buttons, hidden on small screens */}
        <div className="hidden md:block relative w-full md:w-auto md:flex-grow overflow-hidden">
          <div
            ref={scrollContainerRef}
            className="flex justify-between space-x-2 md:space-x-4 overflow-x-auto py-2 md:px-8 scrollbar-hide"
          >
            {filterOptions.map((option) => (
              <FilterButton
                key={option.id}
                option={option}
                isSelected={selectedFilters.includes(option.id)}
                onClick={toggleFilter}
              />
            ))}
          </div>
        </div>

        {/* Clear filters button, visible only on larger screens */}
        <div className="hidden md:block relative">
          <button
            onClick={clearAllFilters}
            className="relative bg-grayBack text-sm text-white font-ubuntu px-4 py-2 rounded-md shadow-md flex items-center"
          >
            <img
              src={images.filterIcon} // Replace with actual filter icon path
              alt="Filter icon"
              className="w-[22px] h-[19px] mr-2"
            />
            Filters
          </button>

          {/* Badge - number of selected filters */}
          {selectedFilters.length > 0 && (
            <span className="font-ubunt absolute top-0 right-0 -mt-2 -mr-2 bg-primary text-white text-xs rounded-full w-5 h-5 flex items-center justify-center border-2 border-white">
              {selectedFilters.length}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
